module.exports = __webpack_public_path__ + "static/media/C1_1.fab9e9d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/C1_1.mp4
// module id = J5Ud
// module chunks = 8